<template>
  <vx-card class="vx-card_full-height">
    <div class="vx-row items-center justify-between flex-wrap flex-shrink-0">
      <div class="vx-col w-auto flex flex items-center flex-wra">
        <h4 class="whitespace-no-wrap">Возвраты</h4>
        <div class="w-auto flex flex-wrap items-center ml-2">
          <div class="mr-2 mb-2">
            <label class="vs-input--label pl-1">Период с:</label>
            <datepicker
              v-model="date_from"
              class="datepicker_small"
              format="MMMM yyyy"
              :minimumView="'month'"
              :maximumView="'year'"
              :disabledDates="disabledDatesFrom"
            />
          </div>
          <div class="mr-2 mb-2">
            <label class="vs-input--label pl-1">По:</label>
            <datepicker
              v-model="date_to"
              class="datepicker_small"
              format="MMMM yyyy"
              :minimumView="'month'"
              :maximumView="'year'"
              :disabledDates="disabledDatesTo"
            />
          </div>
        </div>
      </div>

      <div class="vx-col w-auto flex items-center flex-shrink-0 md:flex-no-wrap flex-wrap">
        <vs-button
          type="border"
          @click="$router.push({name: 'uc_b_refunds_add'})"
          class="mb-2 mr-2 whitespace-no-wrap"
          v-if="$can('rp.refunds', 'write')"
          iconPack="feather"
          icon="icon-plus"
          title="Добавить"
        >
          Добавить
        </vs-button>
      </div>
    </div>

    <div class="pt-6 flex flex-col flex-1">
      <grid-infinite-scroll
        ref="table"
        :columns="columns"
        :getData="getData"
        :rowHeight="50"
        :maxConcurrentDatasourceRequests="4"
        :pinnedRowsGetters="pinnedRowsGetters"
        :getPinnedRows="getPinnedRows"
        :filterable="false"
        :sortable="false"
        noDataText="Возвраты не найдены"
        :enterMovesDownAfterEdit="true"
        :editable="$can('rp.refunds', 'write')"
        :singleClickEdit="true"
      />
    </div>
  </vx-card>
</template>

<script>
import AgGridActions         from "@/components/common/AgGridActions";
import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";
import notifyHttpError       from "@/mixins/notifyHttpError";

export default {
  name:     "Refunds",
  mixins:   [notifyHttpError],
  data() {
    const dateFrom = new Date();
    dateFrom.setMonth(dateFrom.getMonth() - 3);

    return {
      date_from: dateFrom,
      date_to:   Date.now(),

      totalAllAmount: null,
    };
  },
  computed: {
    pinnedRowsGetters() {
      return {
        account_number: 'Всего',
        all_amount:     ( data ) => {
          return this.$options.filters.numberWithSpaces(data.all_amount);
        },
      };
    },
    columns() {
      return [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          sortable:              true,
          filter:                true,
          pinned:                'left',
          editable:              false,
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:  'Собственник',
          field:       'apartment_owner',
          minWidth:    320,
          sortable:    true,
          filter:      true,
          editable:    false,
          pinned:      'left',
          valueGetter: ( { data } ) => data.apartment_owner ? data.apartment_owner : '-',
        },
        {
          headerName:        'Сумма возврата',
          field:             'all_amount',
          filter:            "number",
          minWidth:          100,
          suppressSizeToFit: false,
          editable:          false,
          pinned:            'left',
          valueGetter:       ( { data } ) => {
            return this.$options.filters.numberWithSpaces(Number(data.all_amount).toFixed(2));
          },
        },
        {
          headerName:        'Дата добавления',
          field:             'created_at',
          filter:            "date",
          minWidth:          120,
          suppressSizeToFit: false,
          editable:          false,
          valueGetter:       ( { data } ) => {
            return data.created_at ? this.$options.filters.moment(this.$parseDateFromString(data.created_at.split("T")[0])) : '-';
          },
        },
        {
          headerName:        'Дата создания',
          field:             'payment_create_date',
          filter:            "date",
          minWidth:          120,
          suppressSizeToFit: false,
          editable:          false,
          valueGetter:       ( { data } ) => {
            return data.payment_create_date ? this.$options.filters.moment(this.$parseDateFromString(data.payment_create_date)) : '';
          },
        },
        {
          headerName:  'Комментарий',
          field:       'comment',
          flex:        2,
          minWidth:    200,
          filter:      false,
          editable:    false,
          valueGetter: ( { data } ) => {
            return data.comment;
          },
        },
        {
          headerName:  'Чек',
          field:       'check_number',
          filter:      "number",
          minWidth:    80,
          editable:    false,
          valueGetter: ( { data } ) => data.check_number || '-',
        },
        {
          headerName:  'Создатель',
          field:       'author',
          minWidth:    160,
          editable:    false,
          valueGetter: ( { data } ) => data.author ? data.author.name : '-',
        },
        {
          headerName:            '  ',
          field:                 'actions',
          filter:                false,
          sortable:              false,
          minWidth:              80,
          maxWidth:              80,
          editable:              false,
          hide:                  !this.$can('rp.refunds', 'write'),
          cellRendererFramework: AgGridActions,
          cellRendererParams:    ( { data } ) => {
            if (!data) return {};
            return {
              actions: [{
                icon:   'icon-trash',
                title:  'Удалить',
                action: () => {
                  const modal = this.$modal.openConfirm({
                    message:    'Вы действительно хотите удалить возврат?',
                    buttonText: 'Удалить',
                  });
                  modal.result
                    .then(() => this.$http.delete(`/refund/${data.id}`, { params: { buildings_id: data.buildings_id } }))
                    .then(() => this.$refs.table.resetData())
                    .catch(this.notifyHttpError);
                },
              }],
            };
          },
        },
      ];
    },
    disabledDatesFrom() {
      return {
        from: new Date(this.date_to),
      };
    },
    disabledDatesTo() {
      return {
        to: new Date(this.date_from),
      };
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    updatePayments() {
      this.$refs.table.resetData();
    },

    getPinnedRows( filters, orderBy ) {
      return Promise.resolve([{
        all_amount: this.totalAllAmount,
      }]);
    },

    getData( page, filters, orderBy ) {
      return this.$http.get('refund', {
        params: {
          orderby:      orderBy,
          filters:      filters,
          page:         page,
          buildings_id: this.selectedHouseId,
          from:         this.$options.filters.formatDate(this.date_from),
          to:           this.$options.filters.formatDate(this.date_to),
        },
      }).then(( { data } ) => {
        this.totalAllAmount = data.total_all_amount;
        this.$refs.table.updatePinnedRows();
        return {
          response: data.invoices,
          total:    data.invoices.total,
          data:     data.invoices.data,
        };
      });
    },
  },

  mounted() {},
  watch: {
    selectedHouseId() {
      this.updatePayments();
    },
    date_from() {
      this.updatePayments();
    },
    date_to() {
      this.updatePayments();
    },
  },
};
</script>

<style lang="scss">
</style>
